import { SvgIcon, SvgIconProps } from '@mui/material'

const FlightIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 20 20">
        <path
            d="M17.44 1.39l.04.042a1.538 1.538 0 010 2.115l-4.172 4.392 2.646 7.511a.506.506 0 01-.057.45l-.06.073-1.646 1.663-3.935-6.483-3.968 4.178.741 1.864c.064.16.04.34-.055.477l-.055.065L5.67 19l-1.87-2.926-2.898-1.887 1.251-1.263a.494.494 0 01.537-.111l1.426.577 4.128-4.346-6.618-4.096L3.27 3.286a.494.494 0 01.518-.118l7.483 2.687 4.2-4.423a1.382 1.382 0 011.967-.041z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </SvgIcon>
)

export default FlightIcon
